import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody, Form, Input, Row, Col, Container } from "reactstrap";

// services
import { showMessage } from "../../services/message.js";
import { api_POST, api_GET } from "../../services/api_service.js";

//Context
import { useAuth } from "../../context/auth";

export default function Declaracao({ item, handleFinalizarCadastro, handleStepAnterior }) {
    const { setLoading, setupSistema } = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [requerimento, set_requerimento] = React.useState(null);

    const [declaracao, set_declaracao] = React.useState("");

    useEffect(() => {
        set_requerimento(item);
        api_GET('setupsolicitacao/GetByAcaoId/' + item.setupSolicitacaoAcao_Id)
            .then(result => set_declaracao(result.data.descricaoDeclaracao))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }, []);

    const onSubmit = (data) => {
        if (data.checkDeclaracao != true) {
            showMessage("Aviso", "Você não pode confirmar o cadastro sem aceitar a declaração!", 'error', null);
            return;
        }

        let json_submit = requerimento;
        json_submit.protocolo = null;
        json_submit.textoDeclaracao = declaracao;

        setLoading(true);
        api_POST('requerimento/PostConfirmarDeclaracao ', json_submit)
            .then(result => { showMessage("Aviso", "Seu cadastro foi concluído e será analisado por " + setupSistema?.identificacao + ". Você receberá todas as informações por email.", 'success', function () { handleFinalizarCadastro(requerimento) }) })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div>
                <Card className={`card card-stats`}>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <h2 className="titulo-solicitacao">Declaração </h2>
                            <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                                <Row>
                                    <Col md="12">
                                        <Input type="checkbox" name="checkDeclaracao" innerRef={register({ required: true })} />{declaracao}
                                        <span className="form-check-sign">
                                            <span className="check"></span>
                                        </span>
                                    </Col>
                                    <Col md="6">
                                        <Button color="secundary" onClick={() => handleStepAnterior(requerimento)} className="btn-mobile" type="button"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <Button color="success" className="btn-mobile" type="submit">Confirmar Declaração <i className="fas fa-check"></i></Button>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}           